import React from 'react'

import { TbItalic } from 'react-icons/tb'

import { useIntl } from '@app/intl/Intl'
import { MarkButton } from '@app/lib/inputs/RichEditor/marks/MarkButton'

export const MarkItalicButton = () => {
  const { formatMessage } = useIntl()

  return (
    <MarkButton
      format='Italic'
      icon={<TbItalic />}
      aria-label={formatMessage({ id: 'RichEditor.Mark.Italic' })}
    />
  )
}
